import { useContext, useEffect, useState } from "react";
import "../../styles/login.scss";
import "../../styles/redeem-code.scss";
import { Context } from "../../context/AuthContext";
import RedeemPayment from "./Redeem.Payment";
import RedeemConfirm from "./Redeem.Confirm";
import FFFAPI from "../../services/fffAPI.service";
import Loader from "../../components/controls/Loader";
import { AppState } from "../../appState";
import ProtectedRoute from "../../components/guards/protected-route";
import { useNavigate } from "react-router-dom";

const RedeemCode = () => {
    const navigate = useNavigate();
    const toggleNavigation = AppState((state) => state.toggleNavigation);
    const toggleConversations = AppState((state) => state.toggleConversations);
    const user = useContext(Context);
    const [paymentSucess, setPaymentSuccess] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
      toggleNavigation(false);
      toggleConversations(false);

      const urlParams = new URLSearchParams(window.location.search);
      const success = urlParams.get('success');
      const sessionId = urlParams.get('session_id');
      const canceled = urlParams.get('canceled');

      if (canceled) {
          navigate('/select-plan');
          return;
      }

      if (!success || !sessionId) {
          navigate('/select-plan');
          return;
      }

      // Show confirm page immediately — payment already succeeded via Stripe
      setPaymentSuccess(true);

      // Run analytics + Firebase update in the background (best-effort)
      const processPayment = async () => {
          try {
              const res = await FFFAPI.getCheckoutSession(sessionId);
              const data = res.data;

              // Extract customer ID — handle multiple possible response shapes from backend
              const stripeCustomerId =
                  data?.subscription?.customer ||
                  data?.customer ||
                  data?.stripeCustomerId ||
                  null;

              // Write Premium status — mirrors the RevenueCat pattern:
              // subscriptionInfo.paymentStatus is the single source of truth.
              // The session_id was already verified server-side by getAvantOrderDetails.
              await FFFAPI.updateUser({
                  uid: user?.user?.uid,
                  subscriptionInfo: {
                      paymentStatus: "Premium",
                      currentProvider: "stripe",
                      hadFreeTrial: true,
                      ...(stripeCustomerId ? { stripeCustomerId } : {}),
                  }
              });
          } catch (err) {
              console.error("Error processing payment confirmation:", err);
          }
      };

      processPayment();
  }, []);

  return (
    <ProtectedRoute>
      <div id="redeem-code" className="redeem-code">
        {loading ? (
          <Loader loaderText="Retrieving Data"/>
        ) : 
        !paymentSucess ? (
          <RedeemPayment/>
        ) : (
          <RedeemConfirm />
        )}
      </div>
    </ProtectedRoute>
  );
};

export default RedeemCode;